import React from "react";

const Preloader = ({
  style = {},
  size = "100",
  className = "",
  viewBox = "0 0 100 100",
  color1="#007aff",
  color2="#60b158",
}) => (
  <svg
    width={size}
    style={style}
    height={size}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
  <circle cx="50" cy="50" r="24" strokeWidth="5" stroke={color1} strokeDasharray="37.69911184307752 37.69911184307752" fill="none" strokeLinecap="round">
    <animateTransform attributeName="transform" type="rotate" dur="1.0989010989010988s" repeatCount="indefinite" keyTimes="0;1" values="0 50 50;360 50 50"></animateTransform>
  </circle>
  <circle cx="50" cy="50" r="18" strokeWidth="5" stroke={color2} strokeDasharray="28.274333882308138 28.274333882308138" strokeDashoffset="28.274333882308138" fill="none" strokeLinecap="round">
    <animateTransform attributeName="transform" type="rotate" dur="1.0989010989010988s" repeatCount="indefinite" keyTimes="0;1" values="0 50 50;-360 50 50"></animateTransform>
  </circle>
   </svg>
);

export default Preloader;